import axios from "axios";

const createTechnicianReceive = async (plan) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/TechnicianReceives`, plan)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllTechnicianReceive = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianReceives`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getTechnicianReceive = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianReceives/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getTechnicianReceiveFilter = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianReceives/find-technician-plan${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editTechnicianReceive = async (id, plan) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/TechnicianReceives/${id}`, plan)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteTechnicianReceive = async (id, force) => {
  return axios
    .delete(
      `${process.env.REACT_APP_API_URL}/TechnicianReceives/${id}?force=${force}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getSeqNo = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianReceives/find-plan-seq-no${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getReceiveNo = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianReceives/find-receive-no${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getJobAccept = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianReceives/job-acceptance-inform${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getEquipment = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianReceives/equipment-partsinspection${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getJobDetail = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianReceives/job-description-check${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getSeqNoPartEquip = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianReceives/getseqno-equipment-part${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getSumEquipItem = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechnicianReceives/itemsum/equipment-partsinspection${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const TechnicianReceiveService = {
  createTechnicianReceive,
  getAllTechnicianReceive,
  getTechnicianReceive,
  getTechnicianReceiveFilter,
  getSeqNo,
  getReceiveNo,
  getJobAccept,
  getEquipment,
  getJobDetail,
  getSeqNoPartEquip,
  getSumEquipItem,
  editTechnicianReceive,
  deleteTechnicianReceive
};

export default TechnicianReceiveService;
